import GradientText from '@/common/components/gradient-text';
import Cone from '@/icons/cone';
import IconFuelSmall from '@/icons/icon-fuel-small';
import WrenchSmall from '@/icons/wrench-small';
import { colors } from '@/theme/colors';

export default function getMembershipPanelCopy(gasCents: string) {
  return [
    {
      title: 'Comprehensive maintenance',
      icon: (
        <WrenchSmall
          className="h-[24px] w-[24px] flex-shrink-0"
          fillPrimary={colors.neutral100}
        />
      ),
      description: (
        <p className="body text-flexcar-neutral100">
          Oil changes, tires, brakes, engine and more.
        </p>
      ),
    },
    {
      title: 'Flexcar Gas Saver™',
      icon: (
        <IconFuelSmall
          className="h-[24px] w-[24px] flex-shrink-0"
          fillPrimary={colors.neutral100}
        />
      ),
      description: (
        <GradientText variant="body-strong" from="#00FFCD -54.58%" to="#B4B7FC 100%">
          Save ${gasCents}/gal at Sunoco every time.
        </GradientText>
      ),
    },

    {
      title: '24/7 Roadside assistance',
      icon: (
        <Cone
          className="h-[24px] w-[24px] flex-shrink-0"
          fillPrimary={colors.neutral100}
        />
      ),
      description: (
        <p className="body text-flexcar-neutral100">
          Tows, flat tires, jump-starts, lockouts and more.
        </p>
      ),
    },
  ];
}
